<template>
  <SettingSection
    title="Роли и права"
    icon-variant="roles"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "RolesSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      `,
      links: [
        {
          label: "Пользователи",
          route: { name: "Users" },
        },
        {
          label: "Управление ролями",
          route: { name: "PermissionRoles" },
        },
      ],
    };
  },
};
</script>
